<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <el-select v-model="searchForm.vendorAliasId" filterable clearable placeholder="请选择">
                    <el-option v-for="item in vendorAliasList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="Vendor ID">
                  <el-input type="number" v-model.number="searchForm.inputVendorId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="searchForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button type="primary" @click="searchTableData(true)">{{ $t('common.search') }}</el-button>
            <el-button @click="resetSearchForm">{{ $t('common.reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button class="mb20" type="primary" @click="showForm">新增配置</el-button>

    <el-table :data="tableData" ref="searchTable" :header-cell-style="{backgroundColor: '#f0f0f0'}" border v-loading="loading">
      <el-table-column label="Vendor ID" prop="vendorId"></el-table-column>
      <el-table-column label="买手店" prop="vendorName">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column label="渠道" prop="channelName"></el-table-column>
      <el-table-column label="品牌" prop="brandNames"></el-table-column>
      <el-table-column label="品类" prop="categoryNames"></el-table-column>
      <el-table-column label="时间" prop="createdAt">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="removeItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr mt10">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="searchForm.currentPage"
        small
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total,sizes,prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog :title="`${ruleForm.exemptionId ? '编辑' : '创建'}买手店免检标识`" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
        <el-form-item label="买手店：" prop="vendorId" :rules="[{ required: true, message: '请选择买手店' , trigger: 'change' }]">
          <BrandSelect :data="vendorAliasList" v-model="ruleForm.vendorId" clearable filterable></BrandSelect>
        </el-form-item>
        <el-form-item label="渠道：">
          <el-select v-model="ruleForm.channelIds" @change="onChangeChannel" clearable multiple collapse-tags filterable>
            <el-option label="全部渠道" :value="-1"></el-option>
            <el-option v-for="item in exemptionChannel" :key="item.channelId" :label="item.channelName" :value="item.channelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：">
          <BrandSelect :data="brandList" v-model="ruleForm.brandIds" @change="onChangeBrand" collapse-tags clearable filterable multiple></BrandSelect>
        </el-form-item>
        <el-form-item label="品类：">
          <el-cascader v-model="ruleForm.categoryIds" :options="categoryList" :props="optionProps" collapse-tags clearable :style="{width: '100%'}"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  vendorExemptionChannel,
  vendorExemptionPage,
  saveVendorExemption,
  updateVendorExemption,
  delVendorExemption,
} from './api';
import {
  getBrandList,
} from '../seller/api';
import {
  getComboVendorListRF,
} from '../crm/api';
import {
  getCategory,
} from '../../api/mapping';
import BrandSelect from '../shared/brandSelect.vue';
import utils from '@/utils/util';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      vendorAliasList: [],
      vendorList: [],
      exemptionChannel: [],
      brandList: [],
      categoryList: [],
      searchForm: {
        vendorAliasId: null,
        vendorId: null,
        inputVendorId: null,
        currentPage: 1,
        pageSize: 25,
      },
      loading: false,
      tableData: [],
      totalCount: 0,
      dialogVisible: false,
      ruleForm: {
        exemptionId: null,
        vendorId: null,
        channelIds: [],
        brandIds: [],
        categoryIds: [],
      },
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      },
    };
  },
  mounted() {
    getComboVendorListRF(true).then(res => {
      if (res.data) {
        this.vendorList = (res.data.data || []).map(item => ({
          label: item.vendorName,
          value: item.vendorId,
        }));
        this.vendorAliasList = (res.data.data || []).map(item => ({
          label: `${item.vendorNameAlias} - ${item.vendorName}`,
          value: item.vendorId,
          vendorNameAlias: item.vendorNameAlias,
        }));
      }
    });
    getBrandList().then(res => {
      this.brandList = (res.data || []).map(item => ({
        label: item.englishName,
        value: item.brandId
      }));
      this.brandList.unshift({
        label: '全部品牌',
        value: -1,
      })
    });
    getCategory().then(res => {
      if (res.data && res.data.data) {
        this.categoryList = Object.freeze(this.gatherCategory(res.data.data))
      }
    })
    vendorExemptionChannel().then(res => {
      if (res.data) {
        this.exemptionChannel = res.data;
      }
    })
    this.getTableData();
  },
  methods: {
    searchTableData() {
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    resetSearchForm() {
      this.searchForm.vendorAliasId = null;
      this.searchForm.vendorId = null;
      this.searchForm.inputVendorId = null;
      this.searchForm.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let vendorIds = [];
      if (this.searchForm.inputVendorId) {
        vendorIds = [this.searchForm.inputVendorId];
      } else if (this.searchForm.vendorAliasId) {
        vendorIds = [this.searchForm.vendorAliasId];
      } else if (this.searchForm.vendorId) {
        vendorIds = [this.searchForm.vendorId];
      }
      vendorExemptionPage({
        pageNo: this.searchForm.currentPage,
        pageSize: this.searchForm.pageSize,
        vendorIds,
      }).then(res => {
        if (res.success) {
          this.tableData = res.data.list;
          this.totalCount = res.data.total;
        }
        this.loading = false;
      });
    },
    handleCurrentChange(currentPage) {
      this.searchForm.currentPage = currentPage;
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.getTableData();
    },
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map(item => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onChangeChannel(val) {
      if (val.length > 0 && val[val.length - 1] == -1) {
        this.ruleForm.channelIds = [-1];
      } else if (val.indexOf(-1) > -1) {
        val.splice(val.indexOf(-1), 1);
        this.ruleForm.channelIds = val;
      }
    },
    onChangeBrand(val) {
      if (val.length > 0 && val[val.length - 1] == -1) {
        this.ruleForm.brandIds = [-1];
      } else if (val.indexOf(-1) > -1) {
        val.splice(val.indexOf(-1), 1);
        this.ruleForm.brandIds = val;
      }
    },
    showForm() {
      this.ruleForm.exemptionId = null;
      this.ruleForm.vendorId = null;
      this.ruleForm.channelIds = [];
      this.ruleForm.brandIds = [];
      this.ruleForm.categoryIds = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    editItem(row) {
      this.ruleForm.exemptionId = row.exemptionId;
      this.ruleForm.vendorId = row.vendorId;
      this.ruleForm.channelIds = row.channelIds.map(item => Number(item)) || [];
      this.ruleForm.brandIds = row.brandIds.map(item => Number(item)) || [];
      this.ruleForm.categoryIds = row.categoryIds && row.categoryIds[0] == '-1' ? [] : row.categoryIds.map(item => Number(item)) || [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    submitForm() {
      if (!this.ruleForm.vendorId) {
        this.$message('请选择买手店');
        return;
      }
      if (this.ruleForm.brandIds.length > 0 && this.ruleForm.channelIds.length === 0) {
        this.$message('请选择渠道');
        return;
      }
      if (this.ruleForm.categoryIds.length > 0 && this.ruleForm.brandIds.length === 0) {
        this.$message('请选择品牌');
        return;
      }
      let request = saveVendorExemption;
      if (this.ruleForm.exemptionId) {
        request = updateVendorExemption;
      }
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      request({
        ...this.ruleForm,
        channelIds: this.ruleForm.channelIds[0] == -1 ? [] : this.ruleForm.channelIds,
        brandIds: this.ruleForm.brandIds[0] == -1 ? [] : this.ruleForm.brandIds,
      }).then(res => {
        if (res.success) {
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSave = false;
        }, 1000);
      }).catch(() => {
        setTimeout(() => {
          this.repeatSave = false;
        }, 1000);
      });
    },
    removeItem(row) {
      this.$confirm(`确认删除这条配置吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVendorExemption({
          pkId: row.exemptionId,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.ml5 {
  margin-left: 5px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.tr {
  text-align: right;
}
.f12 {
  font-size: 12px;
}
.red {
  color: red;
}
</style>
